export default __webpack_public_path__ + "static/media/ats-demo-update-red.1f587d11.gif";